import React from 'react';

const Text = ({ 
  size = 'base', 
  children, 
  className = '', 
  as = 'p',
  ...props 
}) => {
  const baseClasses = 'font-sans text-neutral-800';
  
  const sizeClasses = {
    sm: 'text-sm leading-relaxed',
    base: 'text-base leading-relaxed',
    lg: 'text-lg leading-relaxed'
  };

  const Component = as;
  const classes = `${baseClasses} ${sizeClasses[size]} ${className}`;

  return (
    <Component className={classes} {...props}>
      {children}
    </Component>
  );
};

export default Text; 